<template>
	<div>
		<md-dialog :md-active.sync="showDialog">
			<md-dialog-title>Search Advisers</md-dialog-title>
			<md-field class='searcher'>
				<label>Existing advisers name or email</label>
				<md-input v-model="searchText" @keyup='quickSearch' @input="sanitizeSearch"></md-input>
			</md-field>
				<multi-member-picker v-if="searchResults.length >0" v-on:changed="updateSelected" :members="searchResults" :selected="selected" :admin="selectionProp" :iconName="iconName">Advisors goes here...</multi-member-picker>
			<md-dialog-actions>
				<md-button class="md-primary" @click="cancel()">Cancel</md-button>
				<md-button class="md-primary" @click="choose()" :disabled="selected.length <= 0">Choose</md-button>
			</md-dialog-actions>
		</md-dialog>
		<div class="picker-icon picker-name" @click="showDialog = true">
				<font-awesome-icon class='small-icon' icon="plus-circle" /> <span>{{iconName}}</span>
		</div>
	</div>
</template>

<script>
import API from "../services/API";
import MultiMemberPicker from "./MultiMemberPicker";
import { sanitizeInput } from '../utils/sanitizer';
export default {
  name: "MemberPicker",
  props: ['selectionType', 'editAsk', 'section', 'community', "iconName"],
  components: {
    MultiMemberPicker
  },
  data: () => ({
    api: new API(),
    showDialog: false,
    searchText: "",
    selected: [],
    searchResults: [],
    selectionProp: ''
  }),
  methods: {
    cancel: function() {
      this.showDialog = false;
    },
    updateSelected: function(selectedList) {
      this.selected = selectedList;
      this.selectionProp = this.selectionType;
    },
    choose: function() {
      var res = this.selected.length > 0 ? this.selected : [this.searchText];
      this.$emit("chosen", res);
      this.showDialog = false;
    },
    quickSearch: async function() {
      if (this.selectionType === 'administrators') {
        this.$emit('administrator');
      }
      var minLength = 1;
      if (this.section === 'administrators') {
        if (this.searchText.length < minLength) {
          this.searchResults = [];
        } else {
          const {data} = await this.api.get(`communities/${this.community}`);
          await this.api
            .get(`members/search-community-members?term=${this.searchText}&community_id=${data._id}&limit=4`)
            .then(members => {
              this.searchResults = members.data;
            });
        }
      } else {
        if (this.searchText.length < minLength) {
          this.searchResults = [];
        } else {
          await this.api
            .get(`members/search-advisers?term=${this.searchText}&ask_id=${this.$route.params.ask_id}&limit=4`)
            .then(members => {
              this.searchResults = members.data;
            });
        }
      }
    },
    sanitizeSearch(value) {
      this.searchText = sanitizeInput(value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ShowAdviser.vue